import React, { useEffect, useState } from 'react'
import { DatePicker, Select, Button, Table, Spin, Tooltip, Space, message } from 'antd'
import moment from 'moment'
import { InfoCircleOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router'
import { Popover, Tag, Typography } from 'antd'

import Layout from '../../components/layout/Layout'
import axiosInstance from '../../utils/axiosInstance'

import BehaviorPatterns from '../growthProfileComponents/BehaviorPatterns'

const { RangePicker, Avatar } = DatePicker
const { Text } = Typography

const timeZones = [
  {
    value: '-5',
    label: '-5',
  },
  {
    value: '-6',
    label: '-6',
  },
  {
    value: '+5',
    label: '+5',
  },
  {
    value: '+6',
    label: '+6',
  },
]

function GrowthProfile() {
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const [organizations, setOrganizations] = useState([])
  const [selectedOrg, setSelectedOrg] = useState('')
  const [orgMembers, setoOrgMembers] = useState([])
  const [selectedMember, setSelectedMember] = useState('')
  const [data, setData] = useState(null)
  const [calculations, setCalculations] = useState(null)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [timeZone, setTimeZone] = useState(timeZones[0].value)
  const [selectedId, setSelectedId] = useState(null)
  const [selectedLevelIndex, setSelectedLevelIndex] = useState(null)
  const [hoveredIndex, setHoveredIndex] = useState(null)
  const [selectedMonth, setSelectedMonth] = useState(null)
  const [selectedYear, setSelectedYear] = useState(null)
  const [monthTimestamp, setMonthTimestamp] = useState(null)

  const getMyInfo = async () => {
    try {
      setLoading(true)

      const response = await axiosInstance.get(`/api/v1/admin/me`)

      // Check the admin organizations
      if (response?.data?.user?.organizations && response?.data?.user?.organizations.length > 0) {
        const org = response.data.user.organizations
        // console.log(org)

        // store to render at JSX
        org.forEach((element, idx) => {
          if (idx == 0) setSelectedOrg(element._id) // auto selecting the first organization to fetch some results
          setOrganizations((prevElements) => [
            ...prevElements,
            {
              value: element._id,
              label: element.name,
            },
          ])
        })
      }

      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const getData = async (id) => {
    try {
      // console.log(id)

      if (!selectedMonth || !selectedYear || !id) {
        console.log(selectedMonth, selectedYear)
        message.error('Please properly add start & end date! Along with user selection.')
        return
      }

      setLoading(true)

      const payload = {
        timeZone,
        selectedMonth,
        selectedYear,
        userId: id,
      }

      // console.log(payload)

      const response = await axiosInstance.post(`/api/v1/metrics/growthProfile`, payload)

      console.log(response.data)

      setData(response.data.mainData)

      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const getAClubMembers = async (id) => {
    try {
      setLoading(true)

      setoOrgMembers([])

      const response = await axiosInstance.get(`/api/v1/admin/getAClubMembers?clubId=${id}`)

      response.data.users.forEach((element) => {
        setoOrgMembers((prevElements) => [
          ...prevElements,
          {
            value: element._id,
            label: element.firstName + ' ' + element.lastName,
          },
        ])
      })

      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const handleMonthPicker = (date, dateString) => {
    if (date) {
      const month = date.month() + 1 // moment months are 0-indexed, so add 1
      const year = date.year()
      const timestamp = date.valueOf() // Getting epoch timestamp in milliseconds

      setSelectedMonth(month)
      setSelectedYear(year)
      setMonthTimestamp(timestamp)

      console.log('Month:', month)
      console.log('Year:', year)
      console.log('Timestamp:', timestamp)
      console.log('Formatted:', date.format('MMMM YYYY'))
    } else {
      setSelectedMonth(null)
      setSelectedYear(null)
      setMonthTimestamp(null)
    }
  }

  useEffect(() => {
    getMyInfo()
  }, [])

  useEffect(() => {
    if (selectedOrg) {
      getAClubMembers(selectedOrg)
    }
  }, [selectedOrg])

  useEffect(() => {
    // console.log('selectedMember')
    // console.log(selectedMember)
    if (selectedMember) {
      if (selectedMember) {
        getData(selectedMember)
      }
    }
  }, [selectedMember])

  if (organizations.length == 0) return null

  return (
    <Layout>
      <h1>Growth Profile</h1>
      <Space>
        <Select
          placeholder="Please select club or business"
          style={{ width: 250 }}
          defaultValue={organizations[0].value}
          onChange={(value) => {
            setSelectedOrg(value)
            setData(null)
          }}
          options={organizations}
        />

        <DatePicker picker="month" onChange={handleMonthPicker} format="MMMM YYYY" />

        {orgMembers.length && (
          <Select
            placeholder="Select a member (Mandatory)"
            style={{ width: 250 }}
            onChange={(value) => {
              console.log(value)
              setData(null)
              setSelectedMember(value)
            }}
            options={orgMembers}
            showSearch
            filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
            allowClear
          />
        )}

        {/* <Select placeholder="Please select timezone" style={{ width: 100 }} defaultValue={timeZones[0].value} onChange={(value) => setTimeZone(value)} options={timeZones} /> */}

        <Button
          type="primary"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            getData(selectedMember)
          }}
          loading={loading}
        >
          Get data
        </Button>
      </Space>
      <br />
      <br />
      <div style={{ marginTop: 10 }}></div>

      {data && <BehaviorPatterns mainData={data} selectedMonth={selectedMonth} selectedYear={selectedYear} selectedMember={selectedMember} orgMembers={orgMembers} />}
    </Layout>
  )
}

export default GrowthProfile
